<template>
  <div>
    <!-- 头部 -->
    <top></top>
    <!-- logo -->
    <div class="logo">
      <img v-if="bannerArr.length > 0" :src="$imgUrl+bannerArr[0].thumb" alt="" />
    </div>
    <div class="exhibitorList_box" v-html="content"></div>
    <!-- 底部 -->
    <bottom></bottom>
  </div>
</template>
  
  <script>
import top from "../../components/top.vue";
import bottom from "../../components/bottom.vue";
import { getBanner, getSessionHpdetail } from "@/api/api";
export default {
  components: { top, bottom },
  name: "sessionHpdetail",
  // 配置title和meta数据
  metaInfo() {
    return {
      title:this.langSet=='cn'?this.keydata.name_cn:this.keydata.name_en,
      meta: [
        {
          name: "description",
          content: this.keydata.description,
        },
        {
          name: "keywords",
          content: this.keydata.keywords,
        },
      ],
    };
  },
  data() {
    return {
      langSet: "",
      bannerArr: [],
      newsDetail: {},
      id: "",
      content: "",
      keydata:{}
    };
  },
  created() {},
  mounted() {
    let menuArr=JSON.parse(localStorage.getItem('menuArr'))
     menuArr.map(item=>{
      if(item.children){
        item.children.map(i=>{
            if(i.name_cn=='BCEIA 2021概况'||i.name_en=='BCEIA 2021 Overview'){
                this.keydata=i;
          }
        })
      }
       
     })
    this.langSet = localStorage.getItem("languageSet") || "cn";
  this.id = this.$route.params.id;
    this.getBannerList();
    this.getSessionHpdetail(this.id);
  },
  methods: {
    // zhang 获取展商列表banner
    getBannerList() {
      let data = {
        class: "展会概况",
        lang_type: this.langSet,
      };
      getBanner(data)
        .then((res) => {
          if (res.code == 1) {
            this.bannerArr = res.data.lists;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // zhang 获取展会概况
    getSessionHpdetail(id) {
      let data = {
        id: id,
      };
      getSessionHpdetail(data)
        .then((res) => {
          if (res.code == 1) {
            this.content = this.langSet=='cn'?res.data.content:res.data.en_content;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
  watch: {
    $route: {
      handler(val, oldval) {
        this.getSessionHpdetail(val.params.id);
      },
      // 深度观察监听
      deep: true,
    },
  },
};
</script>
  
  <style lang="scss" scoped>
.logo {
  width: 100%;
  height: 400px;
  img {
    width: 100%;
    height: 400px;
  }
}
.custom_btn {
  width: 120px;
  height: 50px;
  border-radius: 12px;
  border: 1px solid #243889;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 18px;
}
.search_btn {
  background: #243889;
  border-radius: 12px;
  color: #ffffff;
  margin: 0 20px;
}
.reset_btn {
  background: #f7f8fa;
  color: #2c2c2e;
}
.exhibitorList_box {
  background: #fff;
  width: 1280px;
  margin: 80px auto;
  .ex_footer {
    background: #fff;
    display: flex;
    justify-content: center;
    width: 100%;
    margin-top: 50px;
  }
  .search_box {
    display: flex;
    .custom_sel {
      position: relative;
      margin-right: 20px;
      .sel::placeholder {
        color: #000 !important;
      }
    }
  }
  .ex_tips {
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 14px;
    color: #999999;
    margin: 20px 0 10px;
  }
  .ex_list {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    .ex_item {
      width: -webkit-calc((100% - 25px * 3)/ 3);
      width: calc((100% - 25px * 3) / 3);
      padding: 15px;
      box-sizing: border-box;
      background: #fff;
      margin: 0 25px 50px 0;
      img {
        width: 100%;
        height: 230px;
      }
      .news_title {
        font-family: PingFangSC, PingFang SC;
        font-weight: 600;
        font-size: 22px;
        color: #2c2c2e;
        line-height: 30px;
        margin: 15px 0;
      }
      .news_time {
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 16px;
        color: #3a3a3c;
      }
    }
  }
  .ex_list::after {
    content: "";
    flex: auto;
  }
  .search_value {
    width: 815px;
    height: 50px;
    background: #ffffff;
    border-radius: 12px;
    border: 1px solid #dddddd;
    padding-left: 55px;
    box-sizing: border-box;
  }
  .search_value::placeholder {
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 18px;
    color: #999999;
  }
}
@media only screen and (max-width: 1280px) {
  .exhibitorList_box{
    width: 90%;
  }
}
@media only screen and (max-width: 767px) {
  .logo{
        width: 100%;
        height:81px !important;
        margin-top: 0.88rem;
        img{
          width: 100%;
          height: 81px  !important;
        }
    }
  .exhibitorList_box{
    width: 90%;
    margin: 30px auto;
    
  }
}
</style>
  <style>
.exhibitorList_box .el-select {
  width: 165px;
  height: 50px;
}
.exhibitorList_box .el-select .el-input__inner {
  height: 50px;
  background: #f7f8fa;
  border-radius: 12px;
  border: none;
}
.exhibitorList_box .el-select > .el-input {
  height: 50px;
}
.exhibitorList_box .el-select .el-input .el-select__caret {
  color: #000;
}
.el-pagination.is-background .el-pager li:not(.disabled).active {
  background: #243889;
  border-radius: 4px;
  border: 1px solid #243889;
}
</style>